import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const DashboardSolidSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.2 0H0.9C0.36 0 0 0.36 0 0.9V7.2C0 7.74 0.36 8.1 0.9 8.1H7.2C7.74 8.1 8.1 7.74 8.1 7.2V0.9C8.1 0.36 7.74 0 7.2 0ZM7.2 9.9H0.9C0.36 9.9 0 10.26 0 10.8V17.1C0 17.64 0.36 18 0.9 18H7.2C7.74 18 8.1 17.64 8.1 17.1V10.8C8.1 10.26 7.74 9.9 7.2 9.9ZM17.1 0H10.8C10.26 0 9.9 0.36 9.9 0.9V7.2C9.9 7.74 10.26 8.1 10.8 8.1H17.1C17.64 8.1 18 7.74 18 7.2V0.9C18 0.36 17.64 0 17.1 0ZM17.1 9.9H10.8C10.26 9.9 9.9 10.26 9.9 10.8V17.1C9.9 17.64 10.26 18 10.8 18H17.1C17.64 18 18 17.64 18 17.1V10.8C18 10.26 17.64 9.9 17.1 9.9Z"
      fill={color}
    />
  </svg>
)

DashboardSolidSvg.defaultProps = {
  width: 18,
  height: 18,
  color: colors.Primary.GreyText
}

export default DashboardSolidSvg
